import { render, staticRenderFns } from "./ValueChainItem.vue?vue&type=template&id=4092611e&scoped=true&"
import script from "./ValueChainItem.vue?vue&type=script&lang=js&"
export * from "./ValueChainItem.vue?vue&type=script&lang=js&"
import style0 from "./ValueChainItem.vue?vue&type=style&index=0&id=4092611e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4092611e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VDatePicker,VMenu,VSelect,VSwitch,VTextField,VTextarea})
